var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContactEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.33398 4.66602L6.77726 8.47631C7.21804 8.78486 7.43844 8.93913 7.67816 8.99889C7.88991 9.05167 8.11139 9.05167 8.32314 8.99889C8.56287 8.93913 8.78326 8.78486 9.22404 8.47631L14.6673 4.66602M4.53398 13.3327H11.4673C12.5874 13.3327 13.1475 13.3327 13.5753 13.1147C13.9516 12.9229 14.2576 12.617 14.4493 12.2407C14.6673 11.8128 14.6673 11.2528 14.6673 10.1327V5.86602C14.6673 4.74591 14.6673 4.18586 14.4493 3.75803C14.2576 3.38171 13.9516 3.07575 13.5753 2.884C13.1475 2.66602 12.5874 2.66602 11.4673 2.66602H4.53398C3.41388 2.66602 2.85383 2.66602 2.426 2.884C2.04968 3.07575 1.74372 3.38171 1.55197 3.75803C1.33398 4.18586 1.33398 4.74591 1.33398 5.86602V10.1327C1.33398 11.2528 1.33398 11.8128 1.55197 12.2407C1.74372 12.617 2.04968 12.9229 2.426 13.1147C2.85383 13.3327 3.41388 13.3327 4.53398 13.3327Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact-email.1c3a7f18.svg";
export { ForwardRef as ReactComponent };